import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReportZoomPage } from './report-zoom.page';

const routes: Routes = [
  {
    path: '',
    component: ReportZoomPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportZoomPageRoutingModule {}
